<template>
  <div class="accordion" id="accordionPanelsStayOpenExample">
    <div class="accordion-item">
      <h2 class="accordion-header">
        <ElButton
          type="accordionHeader"
          target="panelsStayOpen-collapseOne"
          @buttonClick="fcstIsShow"
        >
          <div class="fcst-summary"><i class="pi pi-bars" style="color: slateblue"></i>FY{{ currentYear }} FCST Summary</div>
        </ElButton>
      </h2>

        <!-- <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse"> -->
          <!-- <div class="accordion-body accordion-body-register"> -->
            <div class="table-responsive table-msr-wrap mb-3" v-if="FCST.isShow">
              <table class="table table-so" >
                <thead>
                  <tr>
                    <th
                      style="width: 15%; color: white; background-color: rgb(51, 63, 80)"
                    >
                      Quota
                    </th>
                    <th
                      style="width: 15%; color: white; background-color: rgb(84, 130, 53)"
                    >
                      FCST<span class="fs-sm">(Commit, Won, Close)</span>
                    </th>
                    <th style="width: 5%; background-color: rgb(255, 192, 0)">
                      % vs Quota
                    </th>
                    <th
                      style="width: 15%; color: white; background-color: rgb(48, 84, 150)"
                    >
                      GM
                    </th>
                    <th
                      style="width: 5%; color: white; background-color: rgb(48, 84, 150)"
                    >
                      GM%
                    </th>
                    <th style="width: 15%; background-color: rgb(251, 229, 215)">Risk</th>
                    <th style="width: 15%; background-color: rgb(251, 229, 215)">
                      Bridge
                    </th>
                    <th
                      style="width: 15%; color: white; background-color: rgb(197, 90, 17)"
                    >
                      FCST-Risk+Bridge
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ format(fcstTotal.qty_sum) }}</td>
                    <td>{{ format(fcstTotal.fcstabc) }}</td>
                    <td>{{ format(fcstTotal.fcstper) }}%</td>
                    <td>{{ format(fcstTotal.gmamt) }}</td>
                    <td>{{ format(fcstTotal.gmamtper) }}%</td>
                    <td>{{ format(fcstTotal.riskvaluesum) }}</td>
                    <td>{{ format(fcstTotal.bridgevaluesum) }}</td>
                    <td>{{ format(fcstTotal.fcstriskbridgesum) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          <!-- </div> -->
        <!-- </div> -->
    </div>

    <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업기회 ID">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.sales_id"  @inputKeyupEnter="getOptyList"/>
              </template>
            </ElLabel>
            
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="End User">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.end_user_cmp_nm"  @inputKeyupEnter="getOptyList"/>
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="매출처">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.sales_cmp_nm"  @inputKeyupEnter="getOptyList"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업기회명">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.sales_nm"  @inputKeyupEnter="getOptyList"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
    </div>

    <div class="accordion search-wrap2">
      <div class="accordion-item">
        <div id="detailSearch" class="accordion-collapse collapse">
          <div class="accordion-body detail-body">

            <div class="row">
              <div class="col-md-3">
                <div class="mb-3">
                  <ElLabel name="담당자">
                    <template #end="{id}">
                      <ElInput :id="id" v-model="state.searchParams.manager"  @inputKeyupEnter="getOptyList"/>
                    </template>
                  </ElLabel>
                    
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <ElLabel name="제조사">
                    <template #end="{id}">
                      <ElInput :id="id" v-model="state.searchParams.maker_cmp_nm" @inputKeyupEnter="getOptyList"/>
                    </template>
                  </ElLabel>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <ElLabel name="Stage">
                    <template #end>
                      <SelectCode :cd_gr="'STG_CD'" :matchCd="state.searchParams.stage_cd" @return="r => state.searchParams.stage_cd = r.cd_id" />
                    </template>
                  </ElLabel>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <ElLabel name="상품">
                    <template #end>
                      <TreeSelect 
                          :data-list="state.prodList" 
                          @return="updateProdSelect"
                          v-model="state.prod_class_id"
                          :checkAll="true"/>
                    </template>
                  </ElLabel>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="mb-3">
                  <ElLabel name="영업대표">
                    <template #end="{id}">
                      <ElSelect v-model="state.searchParams.sales_ceo" :options="state.ceoList" />
                    </template>
                  </ElLabel>
                </div>
              </div>
              <!--todo 쿼리 반영 전 -->
              <div class="col-md-3">
                <div class="mb-3">
                  <ElLabel name="매입처">
                    <template #end="{id}">
                      <ElInput :id="id" v-model="state.searchParams.buy_cmp_info_seq" @inputKeyupEnter="getOptyList"/>
                    </template>
                  </ElLabel>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <ElLabel name="납품정보">
                    <template #end="{id}">
                      <ElInput :id="id" v-model="state.searchParams.prd_info" @inputKeyupEnter="getOptyList"/>
                    </template>
                  </ElLabel>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <ElLabel name="Bridge(B)/Risk(R)">
                    <template #end>
                      <SelectCode :cd_gr="'BNR_CD'" :matchCd="state.searchParams.bnr_cd" :hyphenIS="true" @return="r => state.searchParams.bnr_cd = r.cd_id" />
                    </template>
                  </ElLabel>
                </div>
              </div>
            </div>
            <div class="row">
              <ElLabel name="기간조회" >
                <template #end="{id}">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <div class="radio-btn-toggle d-flex">
                        <ElLabel name="매출세금계산서" classNm="btn btn-sm flex-fill">
                          <template #start="{id}">
                            <ElRadio
                              :id="id"
                              ref="btnCheck"
                              classNm="btn-check"
                              value="1"
                              v-model="state.searchParams.tax_ck"
                              @click="checkTaxCk('1')"
                            />
                          </template>
                        </ElLabel>


                        <ElLabel name="매입세금계산서" classNm="btn btn-sm flex-fill">
                          <template #start="{id}">
                            <ElRadio
                              :id="id"
                              ref="btnCheck"
                              classNm="btn-check"
                              v-model="state.searchParams.tax_ck"
                              value="2"
                              @click="checkTaxCk('2')"
                            />
                          </template>
                        </ElLabel>
                        <ElLabel name="우선협상자 선정일" classNm="btn btn-sm flex-fill">
                          <template #start="{id}">
                            <ElRadio
                              :id="id"
                              ref="btnCheck"
                              classNm="btn-check"
                              v-model="state.searchParams.tax_ck"
                              value="3"
                              @click="checkTaxCk('3')"
                            />
                          </template>
                        </ElLabel>
                      </div>
                    </div>
                  </div>
                </template>
              </ElLabel>
              

                <div class="d-flex flex-wrap align-items-center mb-1">
                  <ElButton v-for="item in state.termBtn" :key="item.value"
                    :type="item.active ? 'codeRegistActive' : 'codeRegist'"
                    @buttonClick="setDateTerm(item)">
                    {{ item.name }}
                  </ElButton>

                  <div class="dropdown" style="margin-top:2px; margin-left:0.5rem; min-width:10rem;">
                    <ElButton type="formSelect">
                      {{ state.month.selected ? state.month.selected : '월별 선택' }}
                    </ElButton>
                    <ul class="dropdown-menu"
                      style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(0px, 31px);"
                      data-popper-placement="bottom-start">
                      <li v-for="item in state.month.option" :key="item.value"><a class="dropdown-item" href="#"
                          @click="sethMonth(item)">{{ item.name }}</a></li>
                    </ul>
                  </div>
                  <div class="mt-1 ms-2">
                        <DatePicker v-model="state.year" :format="'yyyy'" :year-picker="true" 
                        @return="r => setYear(r)"/>
                  </div>
                </div>
              
              <div class="col-md-6 mb-3">
                <div class="d-flex">
                  <DatePicker ref="startDatePicker" :selectDate="state.searchParams.tax_dt_s"
                    @return="r => returnDate(r, 'S',false)" /> 
                  <span class="px-2 pt-1">~</span>
                  <DatePicker ref="endDatePicker" :selectDate="state.searchParams.tax_dt_e"
                    @return="r => returnDate(r, 'E',false)" />
                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="search-detail-wrap2">
          <ElButton type="detailBtn" target="detailSearch">상세검색</ElButton>
        </div>
      </div>
    </div>

    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="getOptyList()">검색</ElButton>
      <ElButton type="search" @buttonClick="resetSearchParams()">검색 초기화</ElButton>
    </div>

    <div class="d-flex justify-content-between">
      <div></div>
      <div class="table-btn-group d-flex align-items-center">
        <span class="me-2"><b>Total :</b> {{ state.gridRowData?.length }}</span>
        <img src="/images/vr.png" alt="">
        <ElButton type="list" @buttonClick="state.mode = 'list'">LIST 보기</ElButton>
        <img src="/images/vr.png" alt="">
        <ElButton type="stage" @buttonClick="state.mode = 'stage'">STAGE 보기</ElButton>
        <img src="/images/vr.png" alt="">
        <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
      </div>
    </div>

    <div class="table-responsive table-list" v-if="state.mode == 'list'">
      <DataTable 
        :value="state.gridRowData"
        removableSort
        :default-sort-order="1"
        paginator 
        :rows="10"
        :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
        selectionMode="single"
        @rowSelect="onRowSelect" 
        scrollable
        scrollHeight="550px"
        :sortField="state.sortField" 
        :sortOrder="state.sortOrder"
        :reorderableColumns="true" 
        @columnReorder="onColumnReorder"
         :key="state.refreshKey"
         resizableColumns 
         columnResizeMode="expand"

        
      >
      <template #header>
        <div style="text-align:left">
            <MultiSelect ref="multiSelectRef" :modelValue="selectedColumns" filter :options="state.gridColumn" optionLabel="header" @update:modelValue="onToggle"
                display="chip" placeholder="선택된 컬럼이 없습니다. 선택해주세요."  class="w-full md:w-60rem"
                @change="handleChangeColumn">
            </MultiSelect>
        </div>
      </template>
        <template #empty>
          <div class="center">데이터가 존재하지 않습니다.</div>
        </template>
        <Column>
          <template #header>
              <ElCheckbox v-model="allCheck"/>
          </template>
          <template #body="{ data }" >
              <ElCheckbox 
              v-model="state.selectRows" 
              :value="data"
              />
          </template>
        </Column>
        <Column v-for="(opty,index) of selectedColumns" :key="index" :field="opty.field" :class="opty.class ||''"
          :style="opty.style" sortable :frozen="opty.frozen">
          <template #header>
            <div :class="getHeaderClass(opty)">
              <div>{{ opty.header }}</div>
              <span v-if="opty.subheader && opty.field == 'gm_amt'" style="font-weight: normal;">
                {{numberFomat(state.subtotal[opty.subheader])}}
              </span>
              <span v-else-if="opty.subheader && opty.field == 'outcome_sum'" style="font-weight: normal;"  :headerProps="{ 'aria-sort': 'descending' }">
                {{ numberFomat(state.subtotal[opty.subheader]) }}
              </span>
              <span v-else-if="opty.subheader && opty.field == 'income_sum'" style="font-weight: normal;">
                {{ numberFomat(state.subtotal[opty.subheader]) }}
              </span>
              <span v-else></span>
            </div>
          </template>

          <template #body="{ data, field}">
              <span v-if="opty.field == 'stage_nm'" :class="getOptionStyle(data.stage_cd)">{{ data.stage_nm }}</span>
              <!-- <span v-else-if="opty.field == 'gm_amt'" >{{ data.gm_amt }}</span> -->
              <span v-else-if="opty.field.includes('sum')">{{ priceToString(data[field])
                }}</span>
              <span v-else-if="opty.field.includes('amt')" :class="valueByClass(data.gm_amt)">{{ priceToString(data[field])}}</span>
              <div v-else-if="opty.field == 'outcome_sum'" class="bg-light">{{ data.outcome_sum }}</div>
              <div v-else-if="opty.field === 'manager1' || opty.field === 'sales_ceo' || opty.field === 'bnr_nm'|| opty.field ==='tax_yn'" class="elip-div" style="text-align: center;">
                {{ data[field] }}
              </div>
              <div v-else class="elip-div" :title="data[field]">{{ data[field] }}</div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!--stage mode-->
    <div class="mode-stage d-flex mt-4 table-responsive"  v-else-if="state.mode == 'stage'">
      <div class="stage-steps-container">
      <div class="stage-step">
          <span class="stage-title stage-title-01">Pipline</span>
          <div class="stage-tt">{{ format(stageTotal.pipline) }}<span class="fs-7">원</span></div>
        </div>
        <div class="stage-step">
          <span class="stage-title stage-title-02">Upside</span>
          <div class="stage-tt">{{ format(stageTotal.upside) }}<span class="fs-7">원</span></div>
        </div>
        <div class="stage-step">
          <span class="stage-title stage-title-01">Commit</span>
          <div class="stage-tt">{{ format(stageTotal.commit) }}<span class="fs-7">원</span></div>
        </div>
        <div class="stage-step">
          <span class="stage-title stage-title-02">Won</span>
          <div class="stage-tt">{{ format(stageTotal.won) }}<span class="fs-7">원</span></div>
        </div>
        <div class="stage-step">
          <span class="stage-title stage-title-01">Close</span>
          <div class="stage-tt">{{ format(stageTotal.close) }}<span class="fs-7">원</span></div>
        </div>
      </div>
      <div class="flex-fill" style="display: flex; width: 100%;">
          <div style="width: 20%;">
          <ul class="stage-list">
            <li v-for="pipline of state.stageList.pipline" :key="pipline.opty_seq">
              <div class="stage-list-title" @click="goToOptyDetail(pipline)" :title="pipline.sales_nm">
                  {{ pipline.sales_nm }}
              </div>
              <div class="stage-list-num"><span class="ic-won"></span>{{ format(pipline.outcome_sum) }}</div>
              <div class="stage-list-txt">{{ pipline.end_user_cmp_nm }}</div>
              <div class="stage-list-txt">{{ pipline.sales_ceo }}</div>
            </li>
          </ul>
          </div>
        <div style="width: 20%;">
          <ul class="stage-list">
            <li v-for="upside of state.stageList.upside" :key="upside.opty_seq">
              <div class="stage-list-title" @click="goToOptyDetail(upside)" :title="upside.sales_nm">
                  {{ upside.sales_nm }}
              </div>
              <div class="stage-list-num"><span class="ic-won"></span>{{ format(upside.outcome_sum) }}</div>
              <div class="stage-list-txt">{{ upside.end_user_cmp_nm }}</div>
              <div class="stage-list-txt">{{ upside.sales_ceo }}</div>
              <div class="stage-list-txt">{{ upside.sales_cmp_nm }}</div>
            </li>
          </ul>
        </div>
        <div style="width: 20%;">
          <ul class="stage-list">
            <li v-for="commit of state.stageList.commit" :key="commit.opty_seq">
              <div class="stage-list-title" @click="goToOptyDetail(commit)" :title="commit.sales_nm">
                  {{ commit.sales_nm }}
              </div>
              <div class="stage-list-num"><span class="ic-won"></span>{{ format(commit.outcome_sum) }}</div>
              <div class="stage-list-txt">{{ commit.end_user_cmp_nm }}</div>
              <div class="stage-list-txt">{{ commit.sales_ceo }}</div>
              <div class="stage-list-txt">{{ commit.sales_cmp_nm }}</div>
            </li>
          </ul>
        </div>
        <div style="width: 20%;">
          <ul class="stage-list">
            <li v-for="won of state.stageList.won" :key="won.opty_seq">
              <div class="stage-list-title" @click="goToOptyDetail(won)" :title="won.sales_nm">
                  {{ won.sales_nm }}
              </div>
              <div class="stage-list-num"><span class="ic-won"></span>{{ format(won.outcome_sum) }}</div>
              <div class="stage-list-txt">{{ won.end_user_cmp_nm }}</div>
              <div class="stage-list-txt">{{ won.sales_ceo }}</div>
              <div class="stage-list-txt">{{ won.sales_cmp_nm }}</div>
            </li>
          </ul>
        </div>
        <div style="width: 20%;">
          <ul class="stage-list">
            <li v-for="close of state.stageList.close" :key="close.opty_seq">
              <div class="stage-list-title" @click="goToOptyDetail(close)" :title="close.sales_nm">
                  {{ close.sales_nm }}
              </div>
              <div class="stage-list-num"><span class="ic-won"></span>{{ format(close.outcome_sum) }}</div>
              <div class="stage-list-txt">{{ close.end_user_cmp_nm }}</div>
              <div class="stage-list-txt">{{ close.sales_ceo }}</div>
              <div class="stage-list-txt">{{ close.sales_cmp_nm }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="text-end">
      <ElButton v-if="canUpdate" type="primary" @buttonClick="$router.push('/sr/MSR_SO_001')">신규등록</ElButton>
      <ElButton type="primary" @buttonClick="shareToUser">공유하기</ElButton>
    </div>
  </div>
  <excelUtil ref="excelUtilRef" v-show="false" />
  <!-- 메일발송 모달 (1.컴포넌트) -->
  <EmailSendModal ref="emailSendModalRef" />
</template>

<script setup>
import { reactive, onBeforeMount, ref, computed, onMounted, watch, watchEffect,nextTick  } from 'vue';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import DatePicker from '@/components/common/DatePicker.vue';
import SelectCode from '@/components/common/SelectCode.vue';
import common from '@/js/common';
import excelUtil from "@/components/common/MCO_EX_001.vue";
import TreeSelect from "@/components/common/TreeSelect.vue";
import MultiSelect from 'primevue/multiselect';

import { useUserStore } from "@/store/user";
const userStore = useUserStore();
import { useSearchOptListStore } from "@/store/searchOpyList";
import { useNavigatorStore } from "@/store/navigator";
const searchOptListStore  = useSearchOptListStore();
const navigatorStore = useNavigatorStore();
import { useLoading } from "@/composable/Loading.js";
const { setIsLoading } = useLoading();
import { getLoadUsers } from '@/api/monthly';
import { getProdRevIdList, prodList } from "@/api/prod";
import { userSelect } from "@/api/userInfo";
import { salesOptyList, salesOptyExcelList } from "@/api/sales";
import { getPerformanceFCSTList } from "@/api/monthly";
/** 메일발송 모달 (2.컴포넌트 import 및 참조 선언) */
import EmailSendModal from "@/components/common/modal/EmailSendModal.vue";
import { router } from '@/router';
import 'primeicons/primeicons.css'
import { useOptyColumnStore } from "@/store/optyColumn.js"

const optyColumn = useOptyColumnStore();
const startDatePicker = ref();
const endDatePicker = ref();
const emailSendModalRef = ref();
const excelUtilRef = ref()
const btnCheck = ref();

const selectedColumns = ref([]);
const multiSelectRef = ref(null);

const FCST = reactive({
  list: null,
  isShow: false,
});

onBeforeMount(async () => {
  // 관리자면 전체 list 출력 , 그 외 사용자가 등록한 데이터만 출력
  //사용자 권한 체크 및 user_id 설정
  // await getUserAuth()
  await getProdList()
  await getSalesCeo();
  //영업기회 조회
  if(history.state.stageCd){
    state.searchParams.stage_cd = history.state.stageCd
  }
 if(history.state.quarter && history.state.stage){
    let quarter = history.state.quarter
    const today = new Date();
    const thisYear = today.getFullYear();
    if(quarter  == 1){
      state.searchParams.tax_dt_s = `${thisYear}-01-01`
      state.searchParams.tax_dt_e =`${thisYear}-03-31`
    }else if(quarter  == 2){
      state.searchParams.tax_dt_s = `${thisYear}-04-01`
      state.searchParams.tax_dt_e = `${thisYear}-06-30`
    }else if(quarter  == 3){
      state.searchParams.tax_dt_s = `${thisYear}-07-01`
      state.searchParams.tax_dt_e = `${thisYear}-09-30`
    }else if(quarter  == 4){
      state.searchParams.tax_dt_s = `${thisYear}-10-01`
      state.searchParams.tax_dt_e = `${thisYear}-12-31`
    }
    
    state.searchParams.stage_cd = history.state.stage
    if(history.state.stage =='STG04'){
      state.searchParams.tax_ck = '3'
      state.sortField = 'fmt_won_dt'
      state.sortOrder = -1
    }else{
      state.searchParams.tax_ck = '1'
      state.sortField = 'outcome_sum'
      state.sortOrder = -1
    }
  }else if(history.state.salesIdList){
    state.searchParams.sales_id_list = history.state.salesIdList
    state.searchParams.check_tax_btn = null;
  }else{
    state.searchParams = {...searchOptListStore.searchParams}
    if(searchOptListStore.searchParams.prod_class_id){
      if(searchOptListStore.searchParams.prod_class_id['all']){
        state.prod_class_id['all'] = true
      }else{
        state.prod_class_id={}
        state.prod_class_id[searchOptListStore.searchParams.prod_class_id] = true
      }
      
    }else{
      state.prod_class_id['all'] = true
    }
    if(searchOptListStore.searchParams.tax_ck){
      if(searchOptListStore.searchParams.tax_dt_s && searchOptListStore.searchParams.tax_dt_e && searchOptListStore.searchParams.tax_ck){     
        state.searchParams.tax_dt_s = common.formatDateHyphen(state.searchParams.tax_dt_s)
        state.searchParams.tax_dt_e = common.formatDateHyphen(state.searchParams.tax_dt_e)
      }else{        
        state.searchParams.tax_dt_s = common.dateFormat(oneYear)
        state.searchParams.tax_dt_e = common.dateFormat(endDate)
        state.searchParams.tax_ck = '1'
      }
    }else{
      if(state.searchParams.check_tax_btn !== null){
        state.searchParams.tax_dt_s = common.dateFormat(oneYear)
        state.searchParams.tax_dt_e = common.dateFormat(endDate)
        state.searchParams.tax_ck = '1'
      }
        
    }
    
  }
  await getFCST()
  getYearList()
  // updateProdSelect()
  subTotal()
  await getOptyList()
  selectedColumns.value = optyColumn.optyColumn.map(field => state.gridColumn.find(r => r.field === field))
  .filter(item => item !== undefined);
  if(selectedColumns.value.length == 0){
    selectedColumns.value = state.gridColumn
  }
})

const fcstIsShow = () => {
  FCST.isShow = !FCST.isShow;
};

watchEffect(async () => {
  
  if(!common.isEmpty(selectedColumns.value)){
    optyColumn.saveoptyColumnData(selectedColumns.value.map(r =>{return r.field}))
  }
})

const onToggle = (val) => {
    selectedColumns.value = state.gridColumn.filter(col => val.some(v => v.field === col.field));
};


const onColumnReorder = (event) => {
  if (event.dragIndex !== undefined && event.dropIndex !== undefined) {
    const dragIndex = event.dragIndex;
    const dropIndex = event.dropIndex;

    const newColumns = [...selectedColumns.value]; // 새 배열로 복사
    const [draggedColumn] = newColumns.splice(dragIndex-1, 1); // 드래그된 컬럼 추출
    newColumns.splice(dropIndex-1, 0, draggedColumn);       // 드롭 위치에 삽입

    selectedColumns.value = newColumns; // 새 배열 할당
    
  }
};
const handleChangeColumn = (event) =>{
  const isAllSelected = event.value.length === state.gridColumn.length;

  if(isAllSelected){
    selectedColumns.value = [... state.gridColumn]
  }
  state.refreshKey++;
}

const subTotal = () => {
  const subtotal = {};
  // 초기화된 소계 객체 생성
  state.gridColumn.forEach((col) => {
    if (col.field.includes("sum") || col.field.includes("amt")) {
      subtotal[col.field] = 0;
    } else {
      subtotal[col.field] = "";
    }
  });
  // 데이터를 순회하며 합산
  state.gridRowData.forEach((row) => {
    Object.keys(subtotal).forEach((key) => {
      if (typeof row[key] === "number") {
        subtotal[key] += row[key];
      }
    });
  });

  state.subtotal = subtotal;
};

const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectRows.length;
  },
  set(newValue) {
    state.selectRows = newValue ? state.gridRowData.map((item) => { return item }) : [];
  }
})

const currentYear = computed(() => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(-2); // 두 자리 연도 형식
  return year;
});

let startDate = new Date()
const endDate = new Date(startDate.getFullYear(),'11','31')
const oneYear = new Date(startDate.getFullYear(),'00','01')
const state = reactive({
  mode: 'list',
  month: {
    selected: '',
    option: [
      { name: '월별 선택', value: null },
      { name: '1월', value: 0 },
      { name: '2월', value: 1 },
      { name: '3월', value: 2 },
      { name: '4월', value: 3 },
      { name: '5월', value: 4 },
      { name: '6월', value: 5 },
      { name: '7월', value: 6 },
      { name: '8월', value: 7 },
      { name: '9월', value: 8 },
      { name: '10월', value: 9 },
      { name: '11월', value: 10 },
      { name: '12월', value: 11 },
    ]
  },
  year:'',
  termBtn: [
    { name: '오늘', value: 0, type: 'D', active: false },
    { name: '어제', value: 1, type: 'D', active: false },
    { name: '2일', value: 2, type: 'D', active: false },
    { name: '3일', value: 3, type: 'D', active: false },
    { name: '1주', value: 7, type: 'D', active: false },
    { name: '1개월', value: 1, type: 'M', active: false },
    { name: '3개월', value: 3, type: 'M', active: false },
    { name: '6개월', value: 6, type: 'M', active: false },
    { name: '12개월', value: 1, type: 'Y', active: false },
    { name: '올해', type: 'TY', active: false },
  ],
  selectRows: [],
  gridColumn: [
    { header: "영업기회ID", field: "sales_id", subheader: ' ',  style: {maxWidth: '130px',fontSize: '12px'},frozen: navigatorStore.isMobile?  false:true,headerAlign:'left'},
    { header: "End User", field: "end_user_cmp_nm", subheader: ' ',  style: {fontSize: '12px'},frozen:navigatorStore.isMobile?  false:true  ,headerAlign:'left'},
    { header: "영업기회명", field: "sales_nm", subheader: ' ',  style: {maxWidth: '170px' ,fontSize: '12px'} ,frozen:navigatorStore.isMobile?  false:true ,headerAlign:'left'},
    { header: "상품명", field: "prod_class_nm", subheader: ' ',  style: {textAlign: 'left',fontSize: '12px'} ,headerAlign:'left'},
    { header: "매출금액", field: "outcome_sum", subheader: 'outcome_sum', style: {textAlign: 'right' ,fontSize: '12px'}, class:"bg-light" ,headerAlign:'right'},
    { header: "매입금액", field: "income_sum", subheader: 'income_sum',  style: {textAlign: 'right'  ,fontSize: '12px'}, class:"bg-light" ,headerAlign:'right'},
    { header: "GM Amount", field: "gm_amt", subheader: 'gm_amt',  style: {textAlign: 'right',fontSize: '12px'}, class:"bg-red" ,headerAlign:'right'},
    { header: "매출세금계산서 발행일", field: "fmt_tax_dt", subheader: ' ',  style: {maxWidth: '115px',textAlign: 'center',fontSize: '12px'},headerAlign:'center'},
    { header: "발행여부", field: "tax_yn", subheader: ' ',  style: {maxWidth: '70px',textAlign: 'center',fontSize: '12px'} ,headerAlign:'center'},
    { header: "Stage", field: "stage_nm", subheader: ' ',  style: {maxWidth: '90px',textAlign: 'center',fontSize: '12px'} ,headerAlign:'center'},
    { header: "영업대표", field: "sales_ceo", subheader: ' ',  style: {textAlign: 'center',fontSize: '12px'} ,headerAlign:'center'},
    { header: "우선협상자    선정일", field: "fmt_won_dt",style: {maxWidth: '115px',textAlign: 'center',fontSize: '12px'},headerAlign:'center'},
    { header: "PO 발행일", field: "fmt_po_dt",style:{maxWidth: '115px',textAlign: 'center',fontSize: '12px'},headerAlign:'center'},
    { header: "Bridge(B) Risk(R)", field: "bnr_nm", subheader: ' ',  style: {textAlign: 'center',fontSize: '12px'} ,headerAlign:'center'},
    { header: "매출처", field: "sales_cmp_nm", subheader: ' ',  style: {fontSize: '12px'} ,headerAlign:'left'},
    { header: "제조사", field: "maker_cmp_nm", subheader: ' ',  style: {fontSize: '12px'} ,headerAlign:'left'},
    { header: "담당자", field: "manager1", subheader: ' ',  style: {maxWidth: '80px',textAlign: 'center',fontSize: '12px'} ,headerAlign:'center'},
    { header: "매입처", field: "buy_cmp_nm", subheader: ' ',  style: {fontSize: '12px'} ,headerAlign:'left'},
  ],
  excelCol : [
    { header: "No.", field: "index"},
    { header: "영업기회ID", field: "sales_id"},
    { header: "End User", field: "end_user_cmp_nm"},
    { header: "매출처", field: "sales_cmp_nm"},

    { header: "영업기회명", field: "sales_nm"},
    { header: "회사분류", field: "end_user_cmp_class_nm"},
    { header: "담당자1", field: "manager1"},
    { header: "담당자2", field: "manager2"},
    { header: "제조사", field: "maker_cmp_nm"},
    { header: "매입처", field: "buy_cmp_info_nm"},

    { header: "상품", field: "prod_class_nm"},
    { header: "GPU Model", field: "gpu_model_nm"},
    { header: "GPU Q`ty", field: "gpu_model_qty"},

    { header: "매출금액", field: "outcome_sum"},  // mso-number-format: '0'
    { header: "매입금액", field: "income_sum"},
    { header: "GM Amount", field: "gm_amt"},
    { header: "GM%", field: "gm_amt_per"},

    { header: "매출세금계산서발행일", field: "fmt_tax_dt"},
    { header: "발행여부", field: "tax_yn"},

    { header: "수금일", field: "fmt_collect_dt"},
    { header: "수금여부", field: "collect_yn"},
    { header: "매입세금계산서 발행일", field: "fmt_tax_sale_dt"},
    { header: "매입여부", field: "tax_sale_yn"},
    { header: "지급일", field: "pay_dt"},
    { header: "지급여부", field: "pay_yn"},


    { header: "stage", field: "stage_nm"},
    { header: "Bridge(B) Risk(R)", field: "bnr_nm"},
    { header: "우선협상자 선정일(Won Date)", field: "fmt_won_dt"},
    { header: "PO 발행일(Close Date)", field: "fmt_po_dt"},

    { header: "최초 등록일", field: "fmt_reg_dt"},
    { header: "영업대표", field: "sales_ceo"},
    { header: "검수완료일", field: "fmt_isp_dt"},
    { header: "갱신계약 영업기회 매핑", field: "w_sales_id"},
    { header: "계약만료일", field: "fmt_w_end_dt"},
    { header: "메모", field: "memo"},
  ],
  gridRowData: [],
  stageList: {
    pipline: [],
    upside: [],
    commit: [],
    won: [],
    close: [],
    omit: [],
    lost: [],
  },
  startDt: null,
  endDt: null,
  searchParams: {
    reg_id: '',
    sales_id: '',
    end_user_cmp_nm: '',
    sales_cmp_nm: '',
    maker_cmp_nm: '',
    manager: '',
    stage_cd: '',
    stage_nm: '',
    sales_ceo: '',
    prd_info: '',
    tax_dt_s: null,
    tax_dt_e: null,
    tax_ck: '',
    employee_id: '',
    prod_class_id: {},
    buy_cmp_info_seq: '',
    sales_id_list : '',
    bnr_cd: '',
    check_tax_btn : '1'
  },
  subtotal:'',
  prodList: [],
  lastestRev: '',
  selectedChecked:'1',
  ceoList: [],
  yearList: [],
  prod_class_id:{'all':true},
  sortField : '',
  sortOrder : 0,
  refreshKey:0,
});

const stageTotal = ref({
  pipline : 0,
  upside : 0,
  commit : 0,
  won : 0,
  close : 0,
  omit : 0,
  lost : 0
}) 
const canUpdate = computed(()=>{
  return common.checkAccessAuth('M001M001')
})

const canList = computed(()=>{
  return common.checkAccessAuth('M001M002')
})

/* 영업대표 목록 */
const getSalesCeo = async () => {
  try {
    setIsLoading(true)

    const res = await getLoadUsers({ employee_id: userStore.user.employeeId, auth_grp_id: userStore.user.authGrpId })

    if(userStore.user.authGrpId !=='C')  state.ceoList.push({ text: '전체', value: '' })

    //사용자 목록을 영업대표{text, value} 목록으로 변환
    res.rtn.forEach(user => {

      if(user.auth_grp_id ==='C'){
        state.ceoList.push({ text: user.user_nm, value: user.user_nm })
      }

    });
    
    //영업대표 목록 초기화
    state.searchParams.sales_ceo = state.ceoList[0].value;
  } catch (err) {
    console.error(err);
    alert("영업대표 초기화 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }

};

/* 회계년도 목록 */
const getYearList = () => {
  let year = 2023; //시작년도
  const thisYear = new Date().getFullYear();
  const nextYear = thisYear + 2;

  state.yearList = [];
  while (year <= nextYear) {
    state.yearList.push({ text: year + '년', value: year });
    year++;
  }

  state.year = thisYear;
};

//권한 부여시, 영업관리 조회화면 볼 수 있다.
const getAdminList = (params) => {
  if(userStore.user.authGrpId !== ('ADMIN'&& 'C')&& canList){
      params.auth_grp_id  = 'ADMIN'
  }else{
      params.auth_grp_id = userStore.user.authGrpId
  }
}

//리비전 list 조회
const getRevList = async () => {
  try {
    setIsLoading(true)
    const res = await getProdRevIdList()
    res.rtn.map((item) => {
      let rev_id = item.rev_id.substr(2);
      let maxrevIdVal = state.lastestRev.substr(2);
      if (rev_id > maxrevIdVal) {
        state.lastestRev = item.rev_id;
      }
    })
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
};

//검색 초기화
const resetSearchParams = async() =>{
  state.searchParams = {
    reg_id: '',
    sales_id: '',
    end_user_cmp_nm: '',
    sales_cmp_nm: '',
    maker_cmp_nm: '',
    manager: '',
    stage_cd: '',
    stage_nm: '',
    sales_ceo: '',
    prd_info: '',
    tax_dt_s: common.dateFormat(oneYear),
    tax_dt_e: common.dateFormat(endDate),
    tax_ck: '1',
    employee_id: '',
    prod_class_id: '',
    buy_cmp_info_seq: '',
    sales_id_list: '',
    bnr_cd: '',
    check_tax_btn: '1'
  };
  state.sortField = '';
  state.sortOrder = 0;
  state.prod_class_id={all:true}
  
  await getFCST()
  getYearList()
  updateProdSelect()
  // subTotal()
  await getOptyList()
}

//상품 조회
const getProdList = async () => {
  try {
    setIsLoading(true)
    await getRevList()
    const res = await prodList({ rev_id: state.lastestRev })
    state.prodList = res.rtn.map((item)=>{
      if(item.enable_yn == 'Y'){
        return item
      }else{
        return ''
      }
      
    });
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}
//사용자 조회(권한check)
const getUserAuth = async () => {
  let param = {
    user_id: userStore.user.userID
  }
  //로그인 유저 정보 조회
  try {
    setIsLoading(true)
    const res = await userSelect(param)
    state.searchParams.employee_id = res.rtn.employee_id

    if (res.rtn.auth_grp_id != 'S' && res.rtn.auth_grp_id != 'A') {
      state.searchParams.reg_id = res.rtn.user_id
    }
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}

const getOptionStyle = (item) => {
  const stageValue = item
  let classNm = ''
  if (stageValue == 'STG01') {
    classNm = 'stage stage-pipeline';
  } else if (stageValue == 'STG02') {
    classNm = 'stage stage-upside';
  } else if (stageValue == 'STG03') {
    classNm = 'stage stage-commit';
  } else if (stageValue == 'STG04') {
    classNm = 'stage stage-won';
  } else if (stageValue == 'STG05') {
    classNm = 'stage stage-close';
  } else if (stageValue == 'STG06') {
    classNm = 'stage stage-omit';
  } else if (stageValue == 'STG07') {
    classNm = 'stage stage-lost';
  } 
  return classNm
}


//영업기회 조회
const getOptyList = async () => {
  state.selectRows = []
  try {

    let params = {...state.searchParams}
    if(params.tax_ck){
      if(!params.tax_dt_s || !params.tax_dt_e){
        alert('조회할 시작~종료 날짜를 선택해주세요')
        return
      }
    }else{
      if(params.tax_dt_s || params.tax_dt_e){
        alert('기간조회 기준을 선택해주세요.')
        return
      }
    }


    state.searchParams.sales_id_list = null
    params.tax_dt_s = params.tax_dt_s ? params.tax_dt_s.replaceAll('-','') : ''
    params.tax_dt_e = params.tax_dt_e ? params.tax_dt_e.replaceAll('-','') : ''

    params.ss_user_id = userStore.user.employeeId 

    getAdminList(params)
    setIsLoading(true)
    searchOptListStore.searchParamsData(params)
    const res = await salesOptyList(params)

    state.stageList.pipline = []
    state.stageList.upside = []
    state.stageList.commit = []
    state.stageList.won = []
    state.stageList.close = []
    state.stageList.omit = []
    state.stageList.lost = []

    Object.keys(stageTotal.value).forEach((key)=>{
      stageTotal.value[key] = 0
    })
    //summary 계산 
    state.gridRowData = res.rtn.map((item,index) => {
      item.index = index
      item.gm_amt_per = isNaN(Number(item.gm_amt_per)) ?  item.gm_amt_per : Number(item.gm_amt_per).toFixed(1)
      //stage list 생성 및 fcst,gm sum
      switch (item.stage_cd) {
        case 'STG01':
          state.stageList.pipline.push(item);
          stageTotal.value.pipline += Number(item.outcome_sum)
          break;
        case 'STG02':
          state.stageList.upside.push(item);
          stageTotal.value.upside += Number(item.outcome_sum)
          break;
        case 'STG03':
          state.stageList.commit.push(item);
          stageTotal.value.commit += Number(item.outcome_sum)
          break
        case 'STG04':
          state.stageList.won.push(item);
          stageTotal.value.won += Number(item.outcome_sum)
          break
        case 'STG05':
          state.stageList.close.push(item);
          stageTotal.value.close += Number(item.outcome_sum)
          break
        case 'STG06':
          state.stageList.omit.push(item);
          stageTotal.value.omit += Number(item.outcome_sum)
          break
        case 'STG07':
          state.stageList.lost.push(item);
          stageTotal.value.lost += Number(item.outcome_sum)
          break
      }

      return item
    })
    state.gridrowDataInit = [...state.gridRowData]
    state.gridRowData = state.gridRowData.map(r => {return {...r, gm_amt: Number(r.gm_amt), outcome_sum :Number(r.outcome_sum),income_sum:Number(r.income_sum) }})
    subTotal()
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}

const fcstTotal = ref({})
async function getFCST(){
  try{
    setIsLoading(true)
    let params = {
      employee_id  :['E','ADMIN'].includes(userStore.user.authGrpId) ? '' : userStore.user.employeeId,
      fs_year : new Date().getFullYear()
    }
    if(canList && userStore.user.authGrpId != 'C'){ //영업기회 조회 권한 부여 
      params.employee_id = ''
    }
    const res = await getPerformanceFCSTList(params)

    res.rtn.forEach((item)=> {
      if(!item.class && !item.class_id){
        Object.keys(item).forEach((key)=>{
          if(!fcstTotal.value[key]) fcstTotal.value[key] = 0
          fcstTotal.value[key] += isNaN(Number(item[key])) ? 0 : Number(item[key])
        })
      }
    })
    fcstTotal.value['fcstper'] = ((fcstTotal.value['fcstabcper'] / fcstTotal.value['qty_sum']) * 100).toFixed(0)
    fcstTotal.value['gmamtper'] = ((fcstTotal.value['gmamt'] / fcstTotal.value['fcstabc']) * 100).toFixed(0)

  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}
//datePicker 캘린더 공통 컴포넌트 선택한 날짜 콜백받는 함수
const returnDate = (date, type,isBtn=false) => {
  if(!isBtn){
    state.termBtn.forEach((item)=>{
      item.active = false
    })
  }
 
  if (type == 'S') {
    state.searchParams.tax_dt_s = date
  } else if (type == 'E') {
    state.searchParams.tax_dt_e = date
  }
}

//기간 선택 버튼 클릭 시 날짜 계산 함수
const setDateTerm = (btn) => {
  sethMonth(state.month.option[0])

  let termObj = {}
  for (let i of state.termBtn) {
    if (i.name == btn.name) {
      i.active = true
      termObj = { ...i }
    } else {
      i.active = false
    }
  }

  let startDt = new Date()
  let endDt = new Date()
  
  switch (termObj.type) {
    case 'D':
      endDt.setDate(startDt.getDate() - termObj.value);
      break;
    case 'M':
      endDt.setMonth(startDt.getMonth() - termObj.value);
      break;
    case 'Y':
      endDt.setFullYear(startDt.getFullYear() - termObj.value);
      break;
    case 'TY':
      startDt = new Date(startDt.getFullYear(),'00','01')
      break;
  }

  //어제일경우 
  if (startDt > endDt) {
    let tmp = startDt
    startDt = endDt
    endDt = tmp
  }
  returnDate(common.dateFormat(startDt),'S',true)
  returnDate(common.dateFormat(endDt),'E',true)
  // startDatePicker.value.setDate(startDt)
  // endDatePicker.value.setDate(endDt)

}
//조회 조건 월 선택시 날짜 계산 함수
const sethMonth = (item) => {
  //active false
  state.termBtn.map((i) => {
    i.active = false
  })
  state.month.selected = item.name

  if (item.value != null && item.value != undefined) {
    returnDate(common.dateFormat(new Date(new Date().getFullYear(), item.value, 1)) , 'S',false)
    returnDate(common.dateFormat(new Date(new Date().getFullYear(), item.value + 1, 0)) , 'E',false)
  } else {
    state.searchParams.tax_dt_s = ''
    state.searchParams.tax_dt_e = ''
  }

}

const setYear = (year) => {
  //active false
  state.termBtn.map((i) => {
    i.active = false
  })
  if (year!= null && year != undefined) {
    returnDate(common.dateFormat(new Date(new Date(year, 0, 1))) , 'S',false)
    returnDate(common.dateFormat(new Date(new Date(year, 11, 31))) , 'E',false)
  } else {
    state.searchParams.tax_dt_s = ''
    state.searchParams.tax_dt_e = ''
  }
}



//그리드 셀 선택시 콜백함수
const onRowSelect = (event) => {
  if(canUpdate.value){
    router.push({path : '/sr/MSR_SO_003', state : { opty_seq: event.data.opty_seq, sales_id: event.data.sales_id,prod_rev_id : event.data.prod_rev_id }});
  }else{
    router.push({path : '/sr/MSR_SO_004', state : { opty_seq: event.data.opty_seq, sales_id: event.data.sales_id ,prod_rev_id : event.data.prod_rev_id}});
  }
}

function valueByClass(data){
//FCST-Risk+Bridge ,FCST ,Perf
// if (typeof data !== 'number') {
//       console.error('Expected a number but got:', typeof data);
//       return 'default-class';
//     }
if(Number(data) >= 0){
  return ''
}else if(Number(data) < 0){
  return 'fc-red'
}

}

//숫자 형식 포멧
const format = (number) => {
  return common.checkNumberComma(number) ? common.checkNumberComma(number) : 0
}

async function excelDown(){
  let fileNm = "영업기회 리스트";
  let header = [...state.excelCol];
  let params = {}
  try{
    setIsLoading(true)
    if(state.selectRows.length > 0){
      params.sales_id_list = [...state.selectRows].map((item)=>{
        return item.sales_id
      }).toString()
      params.ss_user_id = userStore.user.employeeId 
      params.auth_grp_id = userStore.user.authGrpId
      
    }else{
      params = {...state.searchParams}

      params.ss_user_id = userStore.user.employeeId 
      params.auth_grp_id = userStore.user.authGrpId

      //기간조회 구분
      if(params.tax_ck){
        if(!params.tax_dt_s || !params.tax_dt_e){
          alert('조회할 시작~종료 날짜를 선택해주세요')
          return
        }
      }else{
        if(params.tax_dt_s || params.tax_dt_e){
          alert('기간조회 기준을 선택해주세요.')
          return
        }
      }

      params.tax_dt_s = params.tax_dt_s ? params.tax_dt_s.replaceAll('-','') : ''
      params.tax_dt_e = params.tax_dt_e ? params.tax_dt_e.replaceAll('-','') : ''
    }
    
    getAdminList(params)
    const res =  await salesOptyExcelList(params)
    let dataList = [...res.rtn].map((item,index)=>{
      item.index = (index+1)
      Object.keys(item).forEach((key)=>{
        if(key === 'outcome_sum' || key === 'gm_amt' || key === 'gm_amt_per' || key === 'income_sum'){
          item[key] = isNaN(Number(item[key])) ? item[key] : Number(item[key])
        }
      })
      return item
    })
    excelUtilRef.value.excelDownload(fileNm, header, dataList);
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }


  // if (state.selectRows && state.selectRows?.length > 0) {
  //   dataList = state.selectRows;
  // } else {
  //   dataList = state.gridRowData;
  // }
}


//공유하기
const shareToUser = () => {
  openEmailSend();
}


/** 메일발송 모달 (3.팝업오픈) */
const openEmailSend = () => {

  //메일정보 초기값
  const emailParams = {
    call_prgm_id: 'MSR_SO_002',
    call_prgm_nm: '영업기회 조회/수정',
    receiver_ids: '',
    receiver_nms: '',
    title: '영업기회 정보 공유드립니다.',
    content: makeEmailContent()
  };

  emailSendModalRef.value.openEmailModal(emailParams);

};

/** 메일발송 모달 (4.메일내용) */
const makeEmailContent = () => {

  //선택된 회사의 목록
  if (state.selectRows?.length > 0) {
    //메일 내용 만들기
    let content = '';
    for (let optySale of state.selectRows) {
      content += `<b>영업기회 ID</b>: ${optySale.sales_id || ''}<br>` 
                  +`<b>End User </b>: ${optySale.end_user_cmp_nm || ''}<br>`
                  +`<b>매출처</b>: ${optySale.sales_cmp_nm || ''}<br>`
                  +`<b>영업기회명</b>: ${optySale.sales_nm || ''}<br>` 
                  +`<b>회사분류</b>: ${optySale.end_user_cmp_class_nm || ''}<br>`
                  +`<b>담당자1</b>: ${optySale.manager1 || ''}<br>`
                  +`<b>담당자2</b>: ${optySale.manager2 || ''}<br>`
                  +`<b>제조사</b>: ${optySale.maker_cmp_nm || ''}<br>`                 
                  +`<b>상품</b>: ${optySale.prod_class_nm || ''}<br>`
                  +`<b>매출금액</b>: ${numberFomat(optySale.outcome_sum) || ''}<br>`
                  +`<b>매입금액</b>: ${numberFomat(optySale.income_sum) || ''}<br>`
                  +`<b>GM Amount</b>: ${numberFomat(optySale.gm_amt) || ''}<br>`
                  +`<b>GM%</b>: ${optySale.gm_amt_per || ''}<br>`                  
                  +`<b>stage</b>: ${optySale.stage_nm || ''}<br>`
                  +`<b>Bridge(B) Risk(R)</b>: ${optySale.bnr_nm || ''}<br>`
                  +`<b>PO 발행일(Close Date)</b>: ${optySale.fmt_po_dt || ''}<br>`
                  +`<b>영업대표: ${optySale.sales_ceo || ''}<br>`
                  +`===================================================<br><br>`;  
    }
    return content;
  }



}

const priceToString = (item) => {
  return item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function updateProdSelect(prodData){
  if(prodData){
    state.searchParams.prod_class_id = prodData.class_id
  }else{
    state.searchParams.prod_class_id = ''
  }
}

function goToOptyDetail(data){
  if(data) router.push({path:'/sr/MSR_SO_003' , state:{opty_seq:data.opty_seq,sales_id:data.sales_id,prod_rev_id :data.prod_rev_id}})
}

function checkTaxCk(val){
  if(state.searchParams.tax_ck === val){
    state.searchParams.tax_ck = null
    state.searchParams.tax_dt_e = ''
    state.searchParams.tax_dt_s = ''
    state.searchParams.check_tax_btn = null
    state.termBtn.forEach((item)=>{
      item.active = false
    })
  }else{
    state.searchParams.check_tax_btn = val
  }
}

function numberFomat(num){
  //payment는 원단위임으로 소수점 노출 x
  num = isNaN(num) ? '0' :Number(num).toFixed(0)
  return common.checkNumberComma(num)
}

const getHeaderClass = (opty) => {
  
  switch (opty.headerAlign) {
    case 'left':
      return 'left-align-header';
    case 'center':
      return 'center-align-header';
    case 'right':
      return 'right-align-header';
    default:
      return 'center-align-header'; // 기본값은 중앙 정렬
  }
};
</script>

<style scoped>
.mode-stage {
  height: 500px;
}
.fcst-summary{
  font-size: 1.05rem;
  color: #315198;
  font-weight: bold;
  margin-left: -15px;
}
.pi-bars:before{
  margin-right: 5px;
}

.subheader {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

.multiselect-wrap .p-multiselect-label-container {
  flex-wrap: wrap; /* 아이템 목록 줄바꿈 활성화 */
}

.multiselect-wrap .p-multiselect-token {
  margin: 2px; /* 아이템 간 간격 조정 */
}

.p-datatable .p-column-header-content {
  display: flex;
  align-items: center ; 
  justify-content: center;
}

.left-align-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.center-align-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  white-space: normal; 
  word-break: keep-all; 
}

.right-align-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
}
</style>